"use strict";

class ApplicationUploadDialogCtrl {

    constructor($scope, $mdDialog, Upload, widgets, $rootScope) {

        this.$mdDialog = $mdDialog;
        this.Upload = Upload;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.widgets = widgets;

        $scope.uploadProgress = 0;
        $scope.uploadResponse = {};


        $scope.cancel = () => {
            this.cancelButton();
        };

        $scope.ok = () => {
            this.ok();
        };

        $scope.upload = (file) => {
            this.upload(file);
        };

    }


    // upload on file select or drop
    upload(file) {
        this.$scope.uploadProgress = 1;

        this.Upload.upload({
            url: 'applications/fileinstall',
            data: {
                file: file
            }
        }).then((response) => {
            this.$scope.uploadResponse.succes = response.data;
            this.$rootScope.$broadcast('applicationsSaved');
            this.widgets.reloadWidgetsData();
            this.ok();
        }, (response) => {
            this.$scope.uploadResponse.error = response.data;
        }, (evt) => {
            let progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            this.$scope.uploadProgress = progressPercentage;
        });
    };


    cancelButton() {
        this.$mdDialog.cancel();
    }


    ok() {
        this.$mdDialog.hide();
    }
}

/*
 * Inject dependicies
 */
ApplicationUploadDialogCtrl.$inject = ['$scope', '$mdDialog', 'Upload', 'widgets', '$rootScope'];

/*
 * Browsify connection: execute controller
 */
module.exports = ApplicationUploadDialogCtrl;
